<template>
  <svg
    width="15"
    height="15"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M1.25012 5.57153C1.25012 5.15732 1.58591 4.82153 2.00012 4.82153H21.9999C22.4141 4.82153 22.7499 5.15732 22.7499 5.57153C22.7499 5.98575 22.4141 6.32153 21.9999 6.32153H2.00012C1.58591 6.32153 1.25012 5.98575 1.25012 5.57153Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.60718 6.32153V16.8999C5.60718 19.3023 7.55474 21.2499 9.95718 21.2499H14.0427C16.4452 21.2499 18.3927 19.3023 18.3927 16.8999V6.32153H5.60718ZM4.10718 5.67153C4.10718 5.20209 4.48774 4.82153 4.95718 4.82153H19.0427C19.5122 4.82153 19.8927 5.2021 19.8927 5.67153V16.8999C19.8927 20.1308 17.2736 22.7499 14.0427 22.7499H9.95718C6.72631 22.7499 4.10718 20.1308 4.10718 16.8999V5.67153Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.14294 9.82141C9.55716 9.82141 9.89294 10.1572 9.89294 10.5714V16.2856C9.89294 16.6998 9.55716 17.0356 9.14294 17.0356C8.72873 17.0356 8.39294 16.6998 8.39294 16.2856V10.5714C8.39294 10.1572 8.72873 9.82141 9.14294 9.82141Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M14.8571 9.82141C15.2713 9.82141 15.6071 10.1572 15.6071 10.5714V16.2856C15.6071 16.6998 15.2713 17.0356 14.8571 17.0356C14.4428 17.0356 14.1071 16.6998 14.1071 16.2856V10.5714C14.1071 10.1572 14.4428 9.82141 14.8571 9.82141Z"
      fill="white"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.71436 2.75012C9.024 2.75012 8.46436 3.30977 8.46436 4.00012V5.57151C8.46436 5.98572 8.12857 6.32151 7.71436 6.32151C7.30014 6.32151 6.96436 5.98572 6.96436 5.57151V4.00012C6.96436 2.48134 8.19557 1.25012 9.71436 1.25012H14.2857C15.8045 1.25012 17.0357 2.48134 17.0357 4.00012V5.57151C17.0357 5.98572 16.6999 6.32151 16.2857 6.32151C15.8715 6.32151 15.5357 5.98572 15.5357 5.57151V4.00012C15.5357 3.30977 14.976 2.75012 14.2857 2.75012H9.71436Z"
      fill="white"
    />
  </svg>
</template>
